import Big from "big.js";

import type { Frequency } from "../../types";

type DistributableFrequency = Extract<Frequency, "MONTHLY" | "QUARTERLY" | "SEMI_ANNUALLY" | "ANNUALLY">

const MONTHS_PER_PERIOD: Record<DistributableFrequency, number> = {
  MONTHLY: 1,
  QUARTERLY: 3,
  SEMI_ANNUALLY: 6,
  ANNUALLY: 12,
};

type InvestmentInput = {
  investedAmount: number;
  returnRate: number;
};

const getDefaultAmount = (
  { investedAmount, returnRate }: InvestmentInput,
  distributionFrequency: Frequency,
  shouldRoundCents = false,
): number => {
  const months = MONTHS_PER_PERIOD[distributionFrequency as DistributableFrequency];

  if (!months) {
    return 0;
  }

  const safeInvestedAmount = Number(investedAmount) || 0;
  const safeReturnRate = Number(returnRate) || 0;

  let distributionAmount = new Big(safeInvestedAmount)
    .times(safeReturnRate)
    .div(100)
    .times(months)
    .div(12);

  if (shouldRoundCents) {
    const cents = distributionAmount.mod(100);
    const roundMode = cents.gte(50) ? Big.roundUp : Big.roundDown;

    distributionAmount = distributionAmount
      .div(100)
      .round(0, roundMode)
      .times(100);
  }

  return distributionAmount.round(0).toNumber();
};

export default getDefaultAmount;
